import styled from 'styled-components';

export const TypeChangeBtnGroupStyled = styled.div`
  .checked {
    color: ${(props) =>
      props.theme[props.brand].chartBox.TypeChangeBtnGroupColor[0]};
      input[type='radio'] {
        opacity: 0;
      }
  }
  .unchecked {
    color: ${(props) =>
      props.theme[props.brand].chartBox.TypeChangeBtnGroupColor[1]};
      input[type='radio'] {
        opacity: 0;
      }
  }
`;
